<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center d-flex justify-content-center" colspan="6">
            <div :class="{'mt-4 section-loading': true}" style="height:20px; width:30px"></div>
            <h3 class="mb-3 pre-formatted">{{content}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "mvMask",
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default:'資料讀取中，請稍候...'
    }
  },
  methods: {},
};
</script>
